export default __webpack_public_path__ + "static/media/user-connected.d1827565.svg";